// @ts-nocheck
/* eslint-disable */
import Item from './item';
import Dialog from "~/ui/dialog";
import { addListener, removeListener, makeEvent } from "~/lib/signals";
import { CONFIG, Scene, setGlobals, store } from "./globals";
import IconAction from "~/ui/icon-action";
import { _ } from "~/i18n";
import MyMapsShare from "~/es6/mymaps.share";
import { MAX_URL_LENGTH } from "~/util/constants";
import { NOTIFICATIONS_TYPE } from "~/util/notifications";
import MyMapsMapyBoxItem from "~/ui/dialogs/mymaps-mapybox-item";
import { getCreateLikeData, mapyboxAnalyticsSave } from "~/util/mapybox";
import { getFolderData } from "~/util/providers/mapybox";
import { createMyMapsSharing } from "~/ui/mymaps/sharing";
import { createUserNote } from "~/ui/user-note/note";
import { setCoordinates } from "~/state/map/state";
import { isNoteHeightSafe } from "~/util/distance-meter-user-marks";
import { icon, node } from "~/util/dom";
import { getNoteVersion, isPremiumNoteUser } from "~/util/user-note";
import MyMapsBox from "~/ui/mymaps/box";
import MyMapsExport from "~/ui/dialogs/mymaps-export";
import createSDSIcon from "~/ui/icon";
import { MYMAPS_CLOSE, MYMAPS_SHARE } from "~/ui/sds-compatible-icons";
import Tooltip, { ETooltipFlow, ETooltipPosition } from "~/ui/tooltip";
import { IMapyBoxItem } from "~/interfaces";
import MyMapsMoveItems from "~/ui/dialogs/mymaps-move-items";
import MyMapsRemove from "~/ui/dialogs/mymaps-remove";
import { createContextMenuBtn } from "~/ui/mymaps/context-menu-btn";

const USERMARKS_ACTION_TRESHOLD = 0;
// cisla jsou posuny px
const CURSOR_ADD = "url(/img/distancemeter/add.png) 3 3, crosshair";
const ITEM_HEIGHT = 87;
const ITEM_EDIT_HEIGHT = 190;

type TMymapsMode = "create" | "edit" | "replace";

export function initModule(global: {
	store: IStore;
	CONFIG: IConfig;
	Scene: any;
}) {
	setGlobals(global);
}

/**
 * Hlavni trida pro zobrazeni uzivatelskych znacek.
 */
export default class UserMarks {
	_ctxtMenuBtn: ReturnType<typeof createContextMenuBtn>;

	_mymapsBox: ReturnType<typeof MyMapsBox>;

	constructor (Notifications) {
		this._notifications = Notifications;
		this._dom = {
			container: node("div", { className: "um-container" })
		};
		this._active = false;
		this._items = [];
		this._cursor = null;
		this._layers = {
			markers: Scene.createLayerMarker()
		};
		this._fromHistory = false;
		this._editItem = null;
		this._likeData = null;
		this._likeChange = false;
		this._fromLike = false;
		this._headerHeight = 0;
		this._readOnly = false;
		this._showMarkerLabel = 0;
		this._userNote = null;
		this._mymapsBox = null;
		this._noteSafeHeight = true;
		this._ctxtMenuBtn = null;
		this._actions = {
			save: new IconAction({
				icon: "star-line",
				title: _("action.save.title"),
				callback: () => {
					const isReplace = this._likeData && "parent_name" in this._likeData;

					this._mymapsDialog(isReplace ? "replace" : "create");
				},
			}),
			share: new IconAction({
				icon: "",
				sdsIcon: MYMAPS_SHARE,
				title: _("action.share.title"),
				callback: function(e) {
					if (window.location.toString().length < MAX_URL_LENGTH) {
						let dataAction = this._getActionState();
						let data = this._likeData && !this._likeChange ? Object.assign({}, this._likeData, { like: !("owner_name" in this._likeData), showLabel: true }) : {
							title: dataAction.title,
							type: "set",
							showLabel: true
						};
						data["usermarksLogData"] = {
							end_points: "share",
							count: this._items.length
						};
						let sharePopup = new MyMapsShare(data, cbData => {
							if (cbData.name == "popup-close") {
								if (this._likeData && !this._likeChange && this._likeData.public != cbData.public) {
									this._likeData.public = cbData.public;
									Mapy.getComponent("places").listRefreshData();
								}
							}
							sharePopup.destroy();
							sharePopup = null;
						});
						sharePopup.open();
					} else {
						this._notifications.notify({
							type: NOTIFICATIONS_TYPE.ERROR,
							content: _("userMarks.URLTooLong"),
							autohide: true,
							duration: 5000
						});
					}
				}.bind(this)
			}),
			download: new IconAction({
				icon: "export2",
				title: _("action.download.title"),
				callback: () => {
					new MyMapsExport({
						data: {
							name: "usermarks",
							data: this._getActionState(),
						},
						onExport: () => {
							this._logger.log("points", { end_points: "download", count: this._items.length });
						},
					}).open();
				},
			}),
			clear: new IconAction({
				icon: "reload",
				title: _("userMarks.reload"),
				callback: function(e) {
					this._logger.log("points", { end_points: "clear", count: this._items.length });
					this.removeAll();
					this._resize();
					Mapy.getComponent("history").save();
					makeEvent("usermarks-clear", this);
				}.bind(this)
			})
		};

		this._noAnimID = null;
		this._resizeID = null;

		this._logger = Mapy.getComponent("logger");

		this._userTitle = null;

		this._build();

		addListener(this, "dim-is-not-share", data => {
			if (this._likeData && data.data.dim == this._likeData.id) {
				this._clearLikeData();
				this.setState(this.getState());
				Mapy.getComponent("history").save();
			}
		}, Mapy.getComponent("dimcurator"));

		// priprava pro tisk
		addListener(this, "print-page", () => {
			this.closeEditItem();

			this._userNote?.print();
			this._mymapsBox?.print();
		});

		window.addEventListener("like.delete", e => {
			if (this._likeData && e.detail.ids.indexOf(this._likeData.id) != -1) {
				this._clearLikeData();
			}
		});

		this._resizeHandler = e => {
			if (this._resizeID) {
				clearTimeout(this._resizeID);
			}

			this._resizeID = setTimeout(() => {
				this._resizeID = null;
				this._resize(e.data);
			}, 333);
		};
	}

	/**
	 * Odstraneni.
	 */
	destroy () { }

	/**
	 * Vrstva pro geometrie.
	 *
	 * @return {SceneLayerGeometry}
	 */
	get layers () {
		return this._layers;
	}

	/**
	 * Vrátí uživatelský titulek
	 * @return {string}
	 */
	get userTitle () {
		return this._userTitle;
	}

	/**
	 * Objekt s textem o uložení
	 */
	get likeText () {
		return this._dom.likeText;
	}

	/**
	 * Ziskani obalu seznamu, kde si vytvori bod svuj radek.
	 *
	 * @return {Element}
	 */
	get itemsContainer () {
		return this._dom.itemsContainer;
	}

	/**
	 * Nastaveni editacniho itemu - pro dalsi operace.
	 *
	 * @param  {Item} item Item nebo null
	 */
	set editItem (item) {
		this._editItem = item;
		this._sortable.enabled = item ? false : true;
		this._dom.container.classList[item ? "add" : "remove"]("global-edit-mode");

		this._setHeights();
	}

	get editItem () {
		return this._editItem;
	}

	get showMarkerLabel() {
		return this._showMarkerLabel;
	}

	/**
	 * Aktivace.
	 */
	activate () {
		if (this._active) return this;

		if (!this._cursor && !this._readOnly && !CONFIG.inFrame) {
			this._cursor = Mapy.Cursor.add({ cursor: CURSOR_ADD, callback: this });
		}

		Scene.addLayer(this._layers.markers).enable();
		this._modulesVisibility();
		this._active = true;

		// bugfix: https://youtrack.sbeta.cz/issue/M-4348 jedna se o to, ze zakazeme drag & drop, ale activate prijde asynchronne pozdejs
		if (!this._editItem) {
			this._sortable.enabled = true;

		}

		this._resizeSignal = addListener(this, "resize", this._resizeHandler);

		let scroll = Mapy.getComponent("layout").getScrollNode();
		scroll && scroll.addEventListener("scroll", this, false);

		this._resize();

		this.show();

		this._logger.log("points", { end_points: "activate", count: this._items.length });
		return this;
	}

	/**
	 * Deaktivace.
	 */
	deactivate () {
		if (!this._active) return this;

		this._onCloseAction && this._onCloseAction();
		this.closeEditItem();

		if (this._cursor) {
			Mapy.Cursor.remove(this._cursor);
			this._cursor = null;
		}

		this._layers.markers.disable();
		Scene.removeLayer(this._layers.markers);
		this._sortable.enabled = false;

		this._active = false;

		removeListener(this._resizeSignal);
		this._resizeSignal = null;

		let scroll = Mapy.getComponent("layout").getScrollNode();
		scroll && scroll.removeEventListener("scroll", this, false);

		this._logger.log("points", { end_points: "deactivate", count: this._items.length });

		return this;
	}

	/**
	 * Zobrazeni kontentu.
	 */
	show () {
		this._dom.container.classList.remove("hide");
		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState({ dim: this._likeData.id });
		}
		else {
			Mapy.CML.state = {
				route: {
					showGeometries: true
				}
			};
		}
	}

	/**
	 * Skryti kontentu.
	 */
	hide () {
		this._dom.container.classList.add("hide");
		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState();
		}

		if (Mapy.active[0] != Mapy.getComponent("search")) {
			Mapy.CML.state = {
				route: {
					showGeometries: false
				}
			};
		}
	}

	/**
	 * Kontainer s celym merenim.
	 *
	 * @return {Element}
	 */
	getContainer () {
		return this._dom.container;
	}

	/**
	 * Ziskani polozek mereni.
	 *
	 * @return {Array}
	 */
	getItems () {
		return this._items;
	}

	/**
	 * Ziskani jedne polozky - souradnic.
	 *
	 * @return {SceneCoords}
	 */
	getOneItem () {
		return (this._items.length ? this._items[0].getCoords() : null);
	}

	/**
	 * Odstraneni polozky na indexu.
	 *
	 * @param  {Number} index
	 */
	remove (index) {
		if (index >= 0 && index < this._items.length) {
			let item = this._items.splice(index, 1)[0];
			item.destroy();
			this._positionUpdate();
		}

		this._updateHeader();
		this._setHeights();

		if (!this._items.length) {
			this._modulesVisibility();
		}
		this._logger.log("points", { end_points: "point-removed", count: this._items.length });
	}

	/**
	 * Odstraneni vsech itemu.
	 */
	removeAll () {
		this._dom.title.textContent = _("userMarks.title");

		while (this._items.length) {
			let item = this._items.pop();
			item.destroy();
		}

		if (!this._fromLike) {
			this._clearLikeData();
		}

		this._noteSafeHeight = true;
		this._modulesVisibility();
		this._updateHeader();
		this._setHeights();
	}

	/**
	 * Polozka byla updatnuta
	 *
	 * @param  {Number} index
	 */
	itemUpdate (index) {
		if (!this._fromLike) {
			this._change(true);
			Mapy.getComponent("history").save(true);
		}
	}

	/**
	 * Zavrit editovany item.
	 */
	closeEditItem () {
		if (this._editItem) {
			this._editItem.editClose();
			this._editItem = null;
		}
	}

	/**
	 * Nastaveni stavu.
	 *
	 * @param {Object} data
	 * @param {String} [data.title = ""] Volitelny titulek
	 */
	setState (data, fromHistory) {
		if ((fromHistory && !data.x && !data.y && !data.z) || CONFIG.inFrame) {
			data.view = true;
		}

		this._onCloseAction = data.onClose || null;

		this._change(false);

		if (data.likeData) {
			this._likeData = data.likeData;
			this._fromLike = true;

			data = {
				view: true,
				uc: this._likeData.data.uc,
				ut: this._likeData.data.ut,
				ud: this._likeData.data.ud,
				title: this._likeData.usertitle || this._likeData.title,
				ol: data.showLabel
			};

			Mapy.CML.state = {
				route: {
					showGeometries: false
				}
			};
			this._ctxtMenuBtn.show();
		}

		this._userTitle = data.title || null;

		if (!data.uc) {
			return;
		}

		if (CONFIG.inFrame && data.ol && !Scene.isM3dActive()) {
			this._showMarkerLabel = "ol" in data ? parseInt(data.ol) : 0 ;
		}

		let tmp = this.getState();

		this._fromHistory = fromHistory;

		/* nezmenilo se */
		if (!fromHistory && JSON.stringify(data.ut) == JSON.stringify(tmp.ut) && JSON.stringify(data.ud) == JSON.stringify(tmp.ud) && data.uc == tmp.uc) {
			this._dom.title.textContent = data.title || _("userMarks.title");

			let coords = Scene.stringToCoords(tmp.uc);
			let centerZoom = Scene.computeCenterZoom(coords, true);
			const [longitude, latitude] = centerZoom[0].toWGS84();

			store.dispatch(setCoordinates({
				longitude,
				latitude,
				...centerZoom[1] == Infinity ? {} : { zoom: centerZoom[1] },
				animate: true,
			}));
			return;
		}

		this.removeAll();
		this._dom.title.textContent = data.title || _("userMarks.title");
		this._dom.likeText.innerHTML = "";
		this._dom.likeText.classList.remove("foreign");
		this._dom.likeText.classList.remove("empty");
		this._userNote?.destroy();
		this._mymapsBox?.destroy();
		this._mymapsBox = null;
		this._userNote = null;

		if (this._likeData) {
			if (this._likeData.foreign) {
				this._dom.likeText.classList.add("foreign");

				this._dom.likeText.append(createMyMapsSharing({
					data: this._likeData,
				}));

				if (this._likeData.description) {
					this._userNote = createUserNote({
						data: this._likeData,
						foreign: true,
						onNoteOpen: container => {
							this._onNoteOpen(container);
						},
					});

					this._dom.likeText.append(this._userNote.container);
				}
			} else {
				this._mymapsBox = new MyMapsBox({
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					data: this._likeData,
					folder: {
						id: this._likeData.parent_id,
						title: this._likeData.parent_name,
					},
					onSignal: signal => {
						switch (signal.name) {
							case "like-update":
								if (this._active) {
									Object.assign(this._likeData, signal.updateData);
									this._dom.title.textContent = this._likeData.usertitle || this._likeData.title;
								}
								break;

							case "note-open":
								this._onNoteOpen(signal.container);
								break;

							case "delete":
								this._clearLikeData();
								Mapy.getComponent("history").save(true);
								break;

							case "like-move":
								this._likeData.parent_id = signal.folderId;
								this._likeData.parent_name = signal.folderTitle;
								break;

							default:
						}
					},
				});

				this._dom.likeText.append(this._mymapsBox.container);
			}
		}

		data.ut = !Array.isArray(data.ut) ? [data.ut] : data.ut;
		data.ud = !Array.isArray(data.ud) ? [data.ud] : data.ud;

		let coords = Scene.stringToCoords(data.uc);
		coords.forEach((coord, ind) => {
			this._addItem(coord, data.ut[ind] || "", data.ud[ind] || "");
		});

		this._modulesVisibility();
		this._setHeights();
		this._resize();

		if (data.view || ("p" in data && data.p == "3")) {
			let centerZoom = Scene.computeCenterZoom(coords, true);

			if (coords.length == 1) {
				const [longitude, latitude] = coords[0].toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					...data.z
						? { zoom: parseInt(data.z) }
						: centerZoom[1] == Infinity
							? {}
							: { zoom: centerZoom[1] },
					animate: false,
				}));
			}
			else {
				const [longitude, latitude] = centerZoom[0].toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					...centerZoom[1] == Infinity ? {} : { zoom: centerZoom[1] },
					animate: !fromHistory && !CONFIG.inFrame,
				}));
			}
		}

		this._fromHistory = false;
		this._fromLike = false;
	}

	/**
	 * Ziskani stavu.
	 *
	 * @return {Object}
	 */
	getState () {
		if (this._likeData && !this._likeChange) {
			return {};
		}

		return this._getStateData();
	}

	handleEvent (e) {
		switch (e.type) {
			case "click":
				if (this._dom.exitBtn.contains(e.target)) {
					if (this._items.length && !(this._likeData && !this._likeChange)) {
						let dialog = new Dialog({
							title: _("userMarks.closeTitle2"),
							desc: _("gpx.content.closeDesc")
						});
						dialog.setBasic({
							closeTxt: "close2",
							bindEnter: true,
							cb: () => {
								this._exit();
							}
						});
						dialog.open();
					}
					else {
						this._exit();
					}
				}
				break;

			case "scroll":
				this._updateHeader();
				break;

			case "sortable-end":
				let fromIndex = e.detail.fromIndex;
				let toIndex = e.detail.toIndex;
				let swap = this._items.splice(fromIndex, 1)[0];

				this._items.splice(toIndex, 0, swap);
				this._positionUpdate();
				this._logger.log("points", { end_points: "sortable-end", count: this._items.length });
				break;
		}
	}

	/**
	 * Zacatek animace - dve tridy, jedna pro staticky seznam, druha vypne transition.
	 */
	noAnimStart () {
		this._clearAnimTO();

		this._dom.container.classList.add("static");
		this._dom.container.classList.add("no-anim");
	}

	/**
	 * Konec animace - nejdrive je potreba se drzet bez animace, provest reset static tridy, pak zapnout animace.
	 */
	noAnimEnd () {
		this._clearAnimTO();

		this._dom.container.classList.remove("static");

		this._noAnimID = setTimeout(() => {
			this._dom.container.classList.remove("no-anim");
		}, 100);
	}

	/**
	 * Pridani noveho itemu.
	 *
	 * @param {SceneCoords} coords Souradnice
	 * @param {String} [label] Titulek
	 * @param {String} [desc] Popisek
	 */
	addItem (coords, label, desc) {
		this.noAnimStart();
		this.closeEditItem();

		let item = this._addItem(coords, label || _("userMarks.label"), desc || coords.toWGS84(2).join(" "));
		item.addFromMap();
		this._dom.scrollSection.scrollTop = item.container.offsetTop;
		this._sectionHighlight(true, item.index);
		this._updateHeader();
		this._setHeights();

		if (this._items.length <= 1) {
			this._modulesVisibility();
		}
		let coord = item.data.coords.toWGS84(0);
		this._logger.log("points", { end_points: "point-added", count: this._items.length, coordsLat: coord[1], coordsLon: coord[0] });
	}

	/**
	 * Klik do mapy.
	 *
	 * @param  {Event} e
	 */
	mapClick (e, smapItem, marker) {
		if (Scene.isM3dActive()) return;

		this.addItem(marker ? marker.getCoords() : Scene.coordsFromEvent(e));

		Mapy.getComponent("history").save(true);

		const scrollNode = Mapy.getComponent("layout").getScrollNode();
		scrollNode.scrollTop = scrollNode.clientHeight;
	}

	/**
	 * Podbarveni itemu.
	 *
	 * @param  {Boolean} isEnter Jedna se o najeti/odjeti
	 * @param  {Number}  index Pozice
	 */
	sectionHighlight (isEnter, index) {
		if (this._editItem) return;

		this._sectionHighlight(isEnter, index);
	}

	readOnly(readOnly) {
		this._readOnly = readOnly;
		this._dom.container.classList[readOnly ? "add" : "remove"]("ro");
		this._sortable.enabled = !readOnly;
		this._appendContentActions();

		if (!readOnly && !this._cursor && this._active && !CONFIG.inFrame) {
			this._cursor = Mapy.Cursor.add({ cursor: CURSOR_ADD, callback: this });
		}

		this._dom.info.classList[readOnly ? "add" : "remove"]("hide");

		if (readOnly && this._cursor) {
			Mapy.Cursor.remove(this._cursor);
			this._cursor = null;
		}

		if (this._items.length) {
			this._items.forEach(i => {
				i.readOnly(this._readOnly);
			});
		}
	}

	/**
	 * Vytvoreni DOMu.
	 */
	_build () {
		// hlavicka
		let header = node("div", { className: "header" });
		let title = node("h1", { className: "title", textContent: _("userMarks.title") });

		const btns = node("div", { className: "header-buttons" });
		const exitBtn = node("button", { className: "edit-props-btn" });

		exitBtn.addEventListener("click", this);
		exitBtn.appendChild(createSDSIcon({ className: "edit-props-btn-icon-exit", symbol: MYMAPS_CLOSE }));

		this._ctxtMenuBtn = createContextMenuBtn({
			place: "usermarks-detail",
			clickCb: name => {
				switch (name) {
					case "edit":
						this._mymapsDialog("edit");
						break;

					case "move-to-folder":
						new MyMapsMoveItems({
							item: this._likeData,
							ids: [this._likeData.id],
							moveFolders: [{
								id: this._likeData.parent_id,
								title: this._likeData.parent_name
							}],
							onSave: (folderId, folderTitle) => {
								this._likeData.parent_id = folderId;
								this._likeData.parent_name = folderTitle;

								this._mymapsBox.rebuild({
									parent_id: folderId,
									parent_name: folderTitle,
								});
							},
						}).open();
						break;

					case "delete":
						new MyMapsRemove({
							data: this._likeData,
							onRemove: () => {
								this._clearLikeData();
								Mapy.getComponent("history").save(true);
							},
						}).open();
						break;

					default:
				}
			},
		});
		this._ctxtMenuBtn.hide();

		header.appendChild(title);
		btns.append(this._ctxtMenuBtn.container, exitBtn);
		header.append(btns);

		// akce
		let contentActions = node("div", { className: "actions" });
		let div = node("div");
		div.appendChild(this._actions.save.container);
		div.appendChild(this._actions.share.container);
		div.appendChild(this._actions.download.container);
		contentActions.appendChild(div);
		contentActions.appendChild(this._actions.clear.container);

		this._dom.contentActions = node("div", {className:"actions"});
		this._appendContentActions();

		// vypis itemu
		let itemsContainer = node("ul", { className: "items" });

		// info
		let info = node("p", { className: "info", textContent: _("userMarks.empty") });

		// hlavicka - sekce
		let headerSection = node("div", { className: "header-section" });
		let likeText = node("div", { className: "like-text" });
		let headerSectionBg = node("div", { className: "header-section-bg" });
		headerSectionBg.appendChild(header);
		headerSectionBg.appendChild(this._dom.contentActions);
		headerSection.appendChild(headerSectionBg);
		headerSection.appendChild(likeText);

		// scroll sekce
		let scrollSection = node("div", { className: "scroll-section" });
		scrollSection.appendChild(itemsContainer);
		scrollSection.appendChild(info);

		this._dom.container.appendChild(headerSection);
		this._dom.container.appendChild(scrollSection);

		// sortable
		this._sortable = new Mapy.Sortable(itemsContainer);
		itemsContainer.addEventListener("sortable-end", this);

		this._dom.title = title;
		this._dom.exitBtn = exitBtn;
		this._dom.info = info;
		this._dom.headerSection = headerSection;
		this._dom.scrollSection = scrollSection;
		this._dom.itemsContainer = itemsContainer;
		this._dom.headerSectionBg = headerSectionBg;
		this._dom.likeText = likeText;
	}

	_appendContentActions() {
		if (!this._dom.contentActions) { return; }
		Mapy.Util.clear(this._dom.contentActions);

		if (this._readOnly) {
			let p = node("p", { className: "ro" }, _("userMarks.readOnly"));
			this._dom.contentActions.appendChild(p);
		}
		else {
			let div = node("div");
			div.appendChild(this._actions.save.container);
			div.appendChild(this._actions.share.container);
			div.appendChild(this._actions.download.container);
			this._dom.contentActions.appendChild(div);
			this._dom.contentActions.appendChild(this._actions.clear.container);
		}
	}

	/**
	 * Pridani noveho itemu.
	 *
	 * @param {SceneCoords} coords Souradnice
	 * @param {String} label Titulek
	 * @param {String} desc Popisek
	 */
	_addItem (coords, label, desc) {
		let newItem = new Item(this, coords, label, desc);

		this._items.push(newItem);
		this._positionUpdate();
		Mapy.createListStyles(this._items.length);

		return newItem;
	}

	/**
	 * Update modulu.
	 */
	_getActionState () {
		if (!this._items.length) { return {}; }

		let state = this._getStateData();
		state.title = this._items.length > 1 ? _("userMarks.favouriteTitle") : this._items[0].data.label;
		state.subtitle = _("userMarks.favouritePoint", {
			NUM: this._items.length,
			TXT: this._items.length
		});

		if (this._likeData) {
			if ("usertitle" in this._likeData) {
				state.usertitle = this._likeData.usertitle;
			}

			if (this._likeData.description) {
				state.description = this._likeData.description;
			}
		}

		return state;
	}

	/**
	 * Podbarveni itemu a markeru.
	 *
	 * @param  {Boolean} isEnter Vstup ano/ne
	 * @param  {Number}  index Pozice itemu 0..n
	 */
	_sectionHighlight (isEnter, index) {
		this._items.forEach((i, ind) => {
			i?.setHover(isEnter, ind === index);
		});
	}

	/**
	 * Update pozici itemu a markeru.
	 */
	_positionUpdate () {
		this._items.forEach((i, ind) => {
			i.index = ind;
		});

		if (!this._fromLike) {
			this._change(true);
		}
	}

	/**
	 * Viditelnost modulu.
	 */
	_modulesVisibility () {
		if (!this._items.length) {
			this._dom.container.classList.add("empty");
		}
		else {
			this._dom.container.classList.remove("empty");
		}
	}

	/**
	 * Update hlavicky - scroll nebo manual.
	 */
	_updateHeader() {
		let scrollTop = Mapy.getComponent("layout").getScrollNode().scrollTop;

		this._dom.headerSection.classList[scrollTop > USERMARKS_ACTION_TRESHOLD ? "add" : "remove"]("scrolled");

		if (Mapy.Util.isMobile()) {
			Mapy.getComponent("userMarks").setBottomPanel();
		}
	}

	/**
	 * mazani dat z moje mapy
	 */
	_clearLikeData () {
		if (this._likeData) {
			this._dom.likeText.innerHTML = "";
			this._dom.likeText.classList.remove("foreign");
			this._dom.likeText.classList.remove("empty");
			this._userNote?.destroy();
			this._mymapsBox?.destroy();
			this._userNote = null;
			this._mymapsBox = null;
			this._change(false);
			this._likeData = null;
			this._ctxtMenuBtn.hide();
			this._actions.save.updateProps = {
				title: _("action.save.title"),
			};

			Mapy.getComponent("dimcurator").setState();

			this._dom.title.textContent = _("userMarks.title");
		}
	}

	/**
	 * doslo ke zmene, tak obarvime prislusne ukladaci button
	 * @param  {Boolean} change zmena
	 */
	_change(change) {
		if (this._likeData) {
			this._likeChange = change;

			if (!("owner_name" in this._likeData)) {
				this._actions.save.props = Object.assign(this._actions.save.props, { change: change, title: change ? _("action.save.changeTitle") : _("action.save.title") });
			}

			if (change && this._likeData.foreign) {
				this._clearLikeData();
			}

			Mapy.getComponent("dimcurator").setState(!change ? { dim: this._likeData.id } : undefined);
		}
	}

	/**
	 * Nastaveni vysky seznamu pro d&d.
	 */
	_setHeights () {
		let normalCount = this._dom.itemsContainer.querySelectorAll(".item:not(.edit-mode)").length;
		let editCount = this._dom.itemsContainer.querySelectorAll(".item.edit-mode").length;
		let height = normalCount * ITEM_HEIGHT + editCount * ITEM_EDIT_HEIGHT;

		this._dom.itemsContainer.style.height = height + "px";
	}

	/**
	 * Vycisteni ID pro no anim timeout.
	 */
	_clearAnimTO () {
		if (this._noAnimID) {
			clearTimeout(this._noAnimID);
			this._noAnimID = null;
		}
	}

	/**
	 * Zmena velikosti - u mobilu dame tahlo pouze na balonek, jinak by neslo scrollovat.
	 */
	_resize(dimensions = {
		width: window.innerWidth,
		height: window.innerHeight
	}) {
		let mobile = Mapy.Util.isSmallResolution();

		this._sortable.options = {
			handle: mobile ? "li .marker-cont" : "li"
		};

		// zmena sticky na absolute a zpet podle vysky hlavicky a layoutu
		this._dom.headerSection.classList[dimensions.height - this._headerHeight < 300 || !this._noteSafeHeight ? "add" : "remove"]("high");
	}

	/**
	 * vrati data stavu vlastnich bodu
	 * @return {Object} data stavu
	 */
	_getStateData () {
		let output = {
			ut: "",
			uc: "",
			ud: ""
		};
		let titles = [];
		let coords = [];
		let desc = [];

		this._items.forEach(item => {
			const data = item?.data;

			if (!data) {
				return;
			}

			titles.push(data.label);
			desc.push(data.desc);
			coords.push(data.coords);
		});

		output.ut = titles;
		output.uc = Scene.coordsToString(coords);
		output.ud = desc;

		return output;
	}

	_exit() {
		this.removeAll();
		this._resize();
		Mapy.getComponent("userMarks").deactivate();
		this._logger.log("points", { end_points: "close", count: this._items.length });
		Mapy.getComponent("history").save();
	}

	_onNoteOpen(container) {
		this._noteSafeHeight = isNoteHeightSafe(container);
		this._resize();
	}

	_mymapsDialog(mode: TMymapsMode) {
		const saveData = this._getActionState();
		const isReplace = mode === "replace" && "parent_name" in this._likeData;
		const folderData = getFolderData();

		if (mode === "create") {
			this._logger.log("click", {
				text: "uložit_hvězda",
				type: "set"
			});
		}

		new MyMapsMapyBoxItem({
			isPremiumUser: isPremiumNoteUser(),
			noteVersion: getNoteVersion(),
			...mode !== "edit"
				? {
					createData: getCreateLikeData(saveData, "set"),
				}
				: {},
			...folderData
				? {
					folder: folderData,
				}
				: {},
			...isReplace || mode === "edit"
				? {
					mode: mode === "edit" ? "edit" : this._likeChange ? "replace" : "save-as-new",
					likeData: this._likeData,
					folder: {
						id: this._likeData.parent_id,
						title: this._likeData.parent_name,
					},
				}
				: {
					mode: "create",
				},
			onSave: ({ likeData: newLikeData }) => {
				this._mymapsDialogSave(mode, newLikeData);
			},
		}).open();
	}

	_mymapsDialogSave(mode: TMymapsMode, likeData: IMapyBoxItem) {
		this._change(false);

		// ulozime
		if (this._likeData) {
			Object.assign(this._likeData, likeData);
		} else {
			this._likeData = likeData;
		}

		if (mode === "create") {
			mapyboxAnalyticsSave({
				type: "set",
				note: !!likeData.description,
			});
		}

		if (mode !== "edit") {
			const isReplace = mode === "replace" && "parent_name" in this._likeData;

			Mapy.getComponent("logger").log("click", {
				type: "set",
				origin: "web",
			});

			if (isReplace) {
				Mapy.getComponent("dimcurator").setState({ dim: this._likeData.id });
				Mapy.getComponent("history").save();
			} else {
				this._logger.log("points", { end_points: "save", count: this._items.length });
			}

			Mapy.getComponent("dimcurator").setState({ dim: likeData.id }).loadData().then(() => {
				Mapy.getComponent("history").save();
			}, () => {});
		} else {
			this._dom.title.textContent = this._likeData.usertitle || this._likeData.title;
		}
	}
}
